import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import {
  CircularProgress,
  FormHelperText,
  Typography,
  withStyles,
} from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import {
  UPDATE_DEALER_SALES_ASSIGN,
  UPDATE_DEALER_USER,
  getAllDealerOptions,
  getAllSalesOptions,
} from "queries";
import { Mutation, Query } from "react-apollo";
import { toast } from "react-toastify";
import useForm from "components/useForm";
import auth from "Auth";
import auth0 from "auth0-js";
import axios from "axios";
import auth0User from "components/Auth0User";
import { GET_USER_INFO } from "queries";
import { withRouter } from "react-router";
import compose from "recompose/compose";
import { CountryRegionData } from "react-country-region-selector";
import { CountryRegionDataUSFirst } from "common/countries";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import Chip from "@material-ui/core/Chip";
import { useQuery } from "@apollo/client";
import {
  DEALER_ASSIGN,
  DELETE_DEALER_ASSIGN,
  GET_ASSIGNED_DEALERS_BY_REGION,
  GET_MY_DEALERS_SALE,
} from "pages/Sales/queries";
import SalesAssignModal from "components/SalesAssignModal";
import { region } from "caniuse-lite";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: "2em",
  },
  textField: {
    marginLeft: theme.spacing(),
    marginRight: theme.spacing(),
    width: "100%",
    margin: "1em",
    textAlign: "center",
  },
  dense: {
    marginTop: 19,
  },
  formControl: {
    margin: theme.spacing(3),
    marginTop: theme.spacing(3),
  },
  addDealer: {
    fontSize: "18px",
    fontWeight: "300",
    textTransform: "uppercase",
    textAlign: "center",
  },
  checkBoxTitle: {
    fontSize: "18px",
    textTransform: "uppercase",
    color: "#1f3340",
    fontWeight: "300",
  },
  updateDealerProfile: {
    marginTop: theme.spacing(4),
    padding: theme.spacing(2),
    fontSize: "14px",
    fontWeight: 100,
  },
  password: {
    marginTop: "4rem",
  },
  menuPaper: {
    maxHeight: 300,
  },
}));

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

const styles = (theme) => ({});
const EditSalesRep = (props) => {
  const {
    match: { params },
    history,
  } = props;
  const { values, handleChange, resetState, handleChangeCheckbox, setValues } =
    useForm(submitForm);

  const classes = useStyles();
  const [isSubmit, setIsSubmit] = useState(false);
  const [selectedField, setSelectedField] = useState([]);
  const [isError, setError] = useState(false);
  const [matchRegion, setMatchRegion] = useState([]);
  const [open, setOpen] = useState(false);
  console.log(open);
  const {
    loading,
    data: dealerData,
    error,
    refetch,
  } = useQuery(getAllDealerOptions, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "cache-and-network",
  });

  useEffect(() => {
    if (selectedField.length > 0) {
      salesAssignRefetch({ regions: selectedField });
    }
  }, [selectedField]);

  const {
    loading: salesAssignLoading,
    data: salesAssignData,
    error: salesAssignEror,
    refetch: salesAssignRefetch,
  } = useQuery(GET_ASSIGNED_DEALERS_BY_REGION, {
    variables: { regions: selectedField },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "cache-and-network",
  });

  const {
    loading: salesLoading,
    data: salesData,
    refetch: salesRefetch,
  } = useQuery(getAllSalesOptions, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "cache-and-network",
  });

  const collectData = dealerData?.profiles?.filter((item) => {
    return selectedField?.some(
      (region) => region?.toLowerCase() === item?.region?.toLowerCase()
    );
  });

  function reloads() {
    refetch();
    salesRefetch();
    setOpen(false);
  }

  // const { loading: assignLoading, error: errors } = useQuery(
  //   GET_MY_DEALERS_SALE,
  //   {
  //     notifyOnNetworkStatusChange: true,
  //     fetchPolicy: "cache-and-network",
  //     variables: { profile_id: params.userId },
  //     onCompleted: (data) => {
  //       const formattedData = data?.sales_assign?.map(
  //         (res) => res?.assign_user_id
  //       );
  //       setSelectedField(formattedData);
  //     },
  //   }
  // );

  const handleUpdatePassword = (event) => {
    if (window.confirm("Are you sure you want to reset dealer's password?")) {
      const webAuth = new auth0.WebAuth({
        domain: "dev-v-8-slj6.auth0.com",
        clientID: "MzOcwoze6f529Uk5GQOXLFHv5bvjetOV",
      });
      webAuth.changePassword(
        {
          connection: "Username-Password-Authentication",
          email: values?.email,
        },
        (err, res) => {
          if (err) {
            toast.error(
              `There was an error trying to reset dealer password. ${res}`,
              {
                position: toast.POSITION.TOP_RIGHT,
              }
            );
          } else {
            toast("A reset password link has been sent to dealer email");
          }
        }
      );
    }
  };

  function permissionsCreator() {
    let permissionsArray = ["sales:SALES_ALL"];
    return permissionsArray;
  }

  const getRegions = (country) => {
    if (!country) {
      return [];
    }
    let parts = country?.split(",")?.slice(2);
    let result = parts?.join(",");

    return result?.split("|").map((regionPair) => {
      let [regionName, regionShortCode = null] = regionPair.split("~");
      return regionName;
    });
  };

  function updateUser(
    data,
    callBackMutation,
    dealerAssign,
    updateDealerSales,
    deleteAssign
  ) {
    let formData = {};
    let accessTokenPromise = auth0User.getToken();
    let AUTH_API_URL = auth0User.AUTH_API_URL();
    setIsSubmit(true);
    accessTokenPromise
      .then((accessToken) => {
        formData.name = data?.name;
        formData.email = data?.email?.toLowerCase();
        formData.company = data?.company;
        formData.address = data?.address;
        formData.address2 = data?.address2;
        formData.city = data?.city;
        formData.region = data?.region;
        formData.zipcode = data?.zipcode;
        formData.phone = data?.phone;
        formData.country = data?.country?.split(",")?.[0];
        formData.role = "Sales";
        formData.profile_id = data?.profile_id;
        formData.parent_admin = auth.getSub();
        formData.permissions = [];
        formData.has_skiff = data?.has_skiff;
        formData.has_seachaser = data?.has_seachaser;
        formData.has_funchaser = data?.has_funchaser;
        formData.location = data?.location;
        formData.business_email = data?.business_email;
        formData.assign_region = JSON.stringify(selectedField);
        axios
          .get(`https://maps.googleapis.com/maps/api/geocode/json`, {
            params: {
              address:
                values?.address +
                " " +
                values?.city +
                " " +
                values?.region +
                "," +
                values?.country[0] +
                " " +
                values?.zipcode,
              key: process.env.REACT_APP_GOOGLE_API_KEY,
            },
          })
          .then(function (response) {
            const { lat, lng } =
              response?.data?.results?.[0]?.geometry?.location;
            formData.location =
              '{ "type": "Point", "coordinates": [' + lng + ", " + lat + "] }";

            axios({
              // url: AUTH_API_URL + "users-by-email",
              url: `${AUTH_API_URL}users/${data?.profile_id}`,
              method: "get",
              headers: { Authorization: `Bearer ${accessToken}` },
              // params: {
              //   email: formData.email
              // }
            })
              .then(function (response) {
                // console.log(response)
                if (response.data !== undefined) {
                  let auth0permissions = permissionsCreator();

                  let user_id = response?.data?.user_id;
                  axios({
                    url: AUTH_API_URL + "users/" + user_id,
                    method: "patch",
                    headers: { Authorization: `Bearer ${accessToken}` },
                    data: {
                      connection: "Username-Password-Authentication",
                      email: formData?.email,
                      name: formData?.name,
                      //password: data.password,
                      user_metadata: {
                        full_name: formData?.name,
                      },
                      app_metadata: {
                        role: "sales",
                        permissions: auth0permissions,
                      },
                    },
                  })
                    .then(function (response) {
                      let permissions = permissionsCreator();
                      formData.permissions = permissions;
                      delete formData.password;
                      delete formData.parent_admin;
                      callBackMutation({
                        variables: formData,
                      }).then(() => {
                        deleteAssign({
                          variables: {
                            profile_id: user_id,
                          },
                        }).then((res) => {
                          const collectDataWithUnassign =
                            dealerData?.profiles?.filter((item) => {
                              return selectedField?.some(
                                (region) =>
                                  region?.toLowerCase() ===
                                  item?.region?.toLowerCase()
                              );
                            });
                          const assignData = collectDataWithUnassign?.map(
                            (res) => ({
                              profile_id: user_id,
                              assign_user_id: res?.profile_id,
                              regions: res?.region,
                            })
                          );
                          dealerAssign({
                            variables: {
                              objects: assignData,
                            },
                          }).then(() => {
                            updateDealerSales({
                              variables: {
                                profile_ids: assignData?.map(
                                  (res) => res?.assign_user_id
                                ),
                                is_sales_assign: true,
                                // assign_region: JSON.stringify(selectedField),
                              },
                            }).then(() => {
                              reloads();
                              completedAdd();
                            });
                          });
                        });
                      });
                      return true;
                    })
                    .catch(function (error) {
                      toast.error("The specified new email already exists", {
                        position: toast.POSITION.TOP_RIGHT,
                      });
                      setIsSubmit(false);
                      // console.log(error)
                    });
                }
              })
              .catch(function (error) {
                toast.error("ERROR: Unable to update dealer", {
                  position: toast.POSITION.TOP_RIGHT,
                });
                setIsSubmit(false);

                // console.log(error)
              });
          })
          .catch((error) => {
            toast.error(
              "Error from getToken() with async( When promise gets rejected ): " +
                error,
              {
                position: toast.POSITION.TOP_RIGHT,
              }
            );
            setIsSubmit(false);
            // console.log(error)
          });
      })
      .catch(function (error) {
        toast.error("Error Getting GEO Location For Address: " + error, {
          position: toast.POSITION.TOP_RIGHT,
        });
        setIsSubmit(false);
        // console.log(error)
      });

    /*  Geocode.setApiKey("AIzaSyAmR2Tn3xehfrBd0-83BrV0Dsg55E_UNT0");
         Geocode.setLanguage("en");
         Geocode.fromAddress(values?.city + "," + values?.region).then(
           response => {
             const { lat, lng } = response.results[0].geometry.location;
             //formData.location = "["+ lat +", "+lng+"]";
             formData.location = '{ "type": "Point", "coordinates": ['+ lat +', '+lng+'] }';
             console.log("lat, lng");
             console.log(lat, lng);
           },
           error => {
             console.error(error);
           }
         ); */
  }

  function updatePermissions(permissionsArray) {
    if (permissionsArray.includes("sales:SALES_ALL")) {
      values.DEALER_ALL = true;
      return permissionsArray;
    }
    return permissionsArray;
  }

  function submitForm() {
    //console.log(values?);
  }
  function completedAdd(payload) {
    toast("Sales Rep was been succesfully updated");
    resetState();
    setIsSubmit(false);
    history.push("/admin-my-sales-rep");
  }

  const handleFieldChangeMultiple = (e) => {
    setSelectedField(e.target.value);
  };

  return (
    <>
      {matchRegion?.length > 0 && (
        <SalesAssignModal
          region={matchRegion}
          open={open}
          setOpen={setOpen}
          collectData={collectData}
          reloads={reloads}
          salesAssignData={salesAssignData?.sales_assign}
        />
      )}
      <Query query={GET_USER_INFO} variables={{ id: params.userId }}>
        {({ loading, error, data }) => {
          if (loading) return <CircularProgress />;
          if (error) return `Error! ${error}`;
          if (values?.email === undefined) {
            const countryData = CountryRegionData?.find(
              (e) => e?.[0] === data?.profiles_by_pk?.country
            );
            setValues({
              ...data?.profiles_by_pk,
              country: countryData?.join(","),
            });
            setSelectedField(
              JSON.parse(data?.profiles_by_pk?.assign_region || null) || []
            );
          }
          updatePermissions(data?.profiles_by_pk?.permissions);
          if (data?.profiles_by_pk !== undefined) {
            return (
              <Mutation
                mutation={UPDATE_DEALER_USER}
                // onCompleted={completedAdd}
              >
                {(updateDealer, { data, loading, called, error }) => {
                  return (
                    <Mutation
                      mutation={UPDATE_DEALER_SALES_ASSIGN}
                      onError={() => setIsSubmit(false)}
                    >
                      {(
                        updateDealerSales,
                        { data, loading, called, error }
                      ) => {
                        if (error) {
                          if (error) {
                            toast.error(error?.graphQLErrors?.[0]?.message);
                          }
                        }
                        return (
                          <Mutation
                            mutation={DEALER_ASSIGN}
                            onError={() => setIsSubmit(false)}
                          >
                            {(
                              dealerAssign,
                              { data, loading, called, error }
                            ) => {
                              if (error) {
                                toast.error(error?.graphQLErrors?.[0]?.message);
                              }
                              return (
                                <Mutation
                                  mutation={DELETE_DEALER_ASSIGN}
                                  onError={() => setIsSubmit(false)}
                                >
                                  {(
                                    deleteDealerAssign,
                                    { data, loading, called, error }
                                  ) => {
                                    if (error) {
                                      toast.error(
                                        error?.graphQLErrors?.[0]?.message
                                      );
                                    }
                                    return (
                                      <form
                                        onSubmit={(e) => {
                                          e.preventDefault();
                                          if (selectedField?.length === 0) {
                                            setError(true);
                                          } else {
                                            const matchedRegions = Array.from(
                                              new Set(
                                                salesData?.profiles
                                                  ?.filter((item) => {
                                                    try {
                                                      if (
                                                        item?.profile_id ===
                                                        params.userId
                                                      )
                                                        return false;
                                                      const regionArray =
                                                        JSON.parse(
                                                          item?.assign_region
                                                        );
                                                      return regionArray?.some(
                                                        (region) =>
                                                          selectedField?.includes(
                                                            region
                                                          )
                                                      );
                                                    } catch (error) {
                                                      console.error(
                                                        "Invalid region format:",
                                                        item?.region
                                                      );
                                                      return false;
                                                    }
                                                  })
                                                  ?.map((item) => ({
                                                    matchRegion: JSON.parse(
                                                      item?.assign_region
                                                    )?.filter((region) =>
                                                      selectedField?.includes(
                                                        region
                                                      )
                                                    ),
                                                    name: item?.name,
                                                    profile_id:
                                                      item?.profile_id,
                                                    region: JSON.parse(
                                                      item?.assign_region
                                                    ),
                                                  }))
                                              )
                                            );
                                            if (matchedRegions?.length > 0) {
                                              setMatchRegion(matchedRegions);
                                              setOpen(true);
                                            } else {
                                              updateUser(
                                                values,
                                                updateDealer,
                                                dealerAssign,
                                                updateDealerSales,
                                                deleteDealerAssign
                                              );
                                            }
                                          }

                                          return false;
                                        }}
                                        className={classes.container}
                                        autoComplete="off"
                                      >
                                        <Grid
                                          container
                                          direction="row"
                                          justify="space-between"
                                          alignItems="center"
                                        >
                                          <Grid
                                            container
                                            direction="row"
                                            justify="space-between"
                                            alignItems="center"
                                            wrap="nowrap"
                                          ></Grid>
                                          <Grid
                                            container
                                            direction="row"
                                            justify="space-between"
                                            alignItems="center"
                                            wrap="nowrap"
                                          >
                                            <TextField
                                              id="name"
                                              name="name"
                                              label="Full Name"
                                              placeholder="Full Name"
                                              className={classes.textField}
                                              margin="normal"
                                              onChange={(e) =>
                                                handleChange(e, "text")
                                              }
                                              value={values?.name || ""}
                                              required
                                              variant="outlined"
                                            />

                                            <TextField
                                              id="phone"
                                              name="phone"
                                              label="Phone"
                                              placeholder="Phone"
                                              className={classes.textField}
                                              margin="normal"
                                              onChange={(e) =>
                                                handleChange(e, "phone")
                                              }
                                              value={values?.phone || ""}
                                              variant="outlined"
                                            />

                                            <TextField
                                              id="company"
                                              name="company"
                                              label="Company Name"
                                              placeholder="Company Name"
                                              className={classes.textField}
                                              margin="normal"
                                              onChange={(e) =>
                                                handleChange(e, "text")
                                              }
                                              value={values?.company || ""}
                                              required
                                              variant="outlined"
                                            />
                                          </Grid>

                                          <Grid
                                            container
                                            direction="row"
                                            justify="space-between"
                                            alignItems="center"
                                            wrap="nowrap"
                                          >
                                            <TextField
                                              id="address"
                                              name="address"
                                              label="Address"
                                              placeholder="Address"
                                              className={classes.textField}
                                              margin="normal"
                                              onChange={(e) =>
                                                handleChange(e, "text")
                                              }
                                              value={values?.address || ""}
                                              required
                                              variant="outlined"
                                            />
                                            <TextField
                                              id="address2"
                                              name="address2"
                                              label="SUITE , APT # , Optional"
                                              placeholder="SUITE , APT # , Optional"
                                              className={classes.textField}
                                              margin="normal"
                                              onChange={(e) =>
                                                handleChange(e, "text")
                                              }
                                              value={values?.address2 || ""}
                                              variant="outlined"
                                            />
                                            <TextField
                                              id="city"
                                              name="city"
                                              label="City"
                                              placeholder="City"
                                              className={classes.textField}
                                              margin="normal"
                                              onChange={(e) =>
                                                handleChange(e, "text")
                                              }
                                              value={values?.city || ""}
                                              required
                                              variant="outlined"
                                            />
                                          </Grid>
                                          <Grid
                                            container
                                            direction="row"
                                            justify="space-between"
                                            alignItems="center"
                                            wrap="nowrap"
                                          >
                                            <TextField
                                              required
                                              id="country"
                                              name="country"
                                              label="Country"
                                              value={values?.country || ""}
                                              select
                                              onChange={handleChange}
                                              className={classes.textField}
                                              inputProps={{
                                                name: "country",
                                                id: "country",
                                              }}
                                              variant="outlined"
                                              SelectProps={{
                                                native: true,
                                                MenuProps: {
                                                  className: classes.menu,
                                                },
                                              }}
                                            >
                                              <option key="" value="" />
                                              {CountryRegionDataUSFirst.map(
                                                (option, index) => (
                                                  <option
                                                    key={option[0]}
                                                    value={option}
                                                  >
                                                    {option[0]}
                                                  </option>
                                                )
                                              )}
                                            </TextField>

                                            <TextField
                                              required
                                              id="region"
                                              name="region"
                                              label="Region"
                                              value={values?.region || ""}
                                              select
                                              className={classes.textField}
                                              SelectProps={{
                                                native: true,
                                                MenuProps: {
                                                  className: classes.menu,
                                                },
                                              }}
                                              onChange={handleChange}
                                              variant="outlined"
                                            >
                                              <option key="" value="" />
                                              {getRegions(values?.country).map(
                                                (option, index) => (
                                                  <option
                                                    key={option[0]}
                                                    value={option}
                                                  >
                                                    {option}
                                                  </option>
                                                )
                                              )}
                                            </TextField>
                                            <TextField
                                              id="zipcode"
                                              name="zipcode"
                                              label="Zipcode"
                                              placeholder="Zipcode"
                                              margin="normal"
                                              onChange={handleChange}
                                              value={values?.zipcode || ""}
                                              required
                                              className={classes.textField}
                                              variant="outlined"
                                            >
                                              <MenuItem>
                                                <em>None</em>
                                              </MenuItem>
                                            </TextField>
                                          </Grid>
                                          <Grid
                                            container
                                            direction="row"
                                            justify="space-between"
                                            alignItems="center"
                                            wrap="nowrap"
                                          >
                                            <TextField
                                              id="email"
                                              name="email"
                                              label="Email"
                                              type="email"
                                              placeholder="Email"
                                              className={classes.textField}
                                              margin="normal"
                                              onChange={(e) =>
                                                handleChange(e, "text")
                                              }
                                              value={values?.email || ""}
                                              variant="outlined"
                                            />
                                            <TextField
                                              id="business_email"
                                              name="business_email"
                                              label="Business Email"
                                              type="email"
                                              placeholder="Business Email"
                                              className={classes.textField}
                                              margin="normal"
                                              onChange={(e) =>
                                                handleChange(e, "text")
                                              }
                                              value={
                                                values?.business_email || ""
                                              }
                                              variant="outlined"
                                            />
                                          </Grid>
                                          <Grid
                                            container
                                            direction="row"
                                            justifyContent="space-between"
                                            alignItems="center"
                                            wrap="nowrap"
                                          >
                                            <FormControl
                                              required
                                              variant="outlined"
                                              className={classes.formControl}
                                              error={error}
                                            >
                                              <InputLabel id="mutiple-chip-label">
                                                Assign Region
                                              </InputLabel>
                                              <Select
                                                className="multi-selecter"
                                                labelId="mutiple-chip-label"
                                                id="mutiple-chip-select"
                                                multiple
                                                value={selectedField}
                                                onChange={
                                                  handleFieldChangeMultiple
                                                }
                                                renderValue={(selected) =>
                                                  selected.join(", ")
                                                }
                                                MenuProps={{
                                                  classes: {
                                                    paper: classes.menuPaper,
                                                  },
                                                }}
                                              >
                                                {getRegions(
                                                  values?.country
                                                )?.map((option) => (
                                                  <MenuItem
                                                    key={option[0]}
                                                    value={option}
                                                  >
                                                    {option}
                                                  </MenuItem>
                                                ))}
                                              </Select>
                                              {isError && (
                                                <FormHelperText
                                                  style={{ color: "red" }}
                                                >
                                                  Please select at least one
                                                  region
                                                </FormHelperText>
                                              )}
                                            </FormControl>
                                          </Grid>
                                          {/* <Grid
                                    container
                                    direction="row"
                                    justify="space-between"
                                    alignItems="center"
                                    wrap="nowrap"
                                  >
                                    <FormControl
                                      variant="outlined"
                                      className={classes.formControl}
                                    >
                                      <InputLabel id="demo-mutiple-chip-label">
                                        Assign Dealer
                                      </InputLabel>
                                      <Select
                                        className="multi-selecter"
                                        labelId="mutiple-chip-label"
                                        id="mutiple-chip-select"
                                        multiple
                                        value={selectedField || []}
                                        onChange={handleFieldChangeMultiple}
                                        renderValue={(selected) => (
                                          <div className={classes.chips}>
                                            {selected?.map((value) => {
                                              const label =
                                                dealerData?.profiles.find(
                                                  (i) => i.profile_id === value
                                                );
                                              return (
                                                <Chip
                                                  key={value?.profile_id}
                                                  label={label?.name || ""}
                                                  className={classes.chip}
                                                />
                                              );
                                            })}
                                          </div>
                                        )}
                                      >
                                        {dealerData?.profiles?.map((name) => (
                                          <MenuItem
                                            key={name?.profile_id}
                                            value={name?.profile_id}
                                          >
                                            {name?.name}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </FormControl>
                                  </Grid> */}
                                          <Grid container>
                                            <Grid item lg={6} align="left">
                                              <FormControl
                                                required
                                                component="fieldset"
                                                className={classes.formControl}
                                              >
                                                <Typography
                                                  className={
                                                    classes.checkBoxTitle
                                                  }
                                                >
                                                  BRANDS CARRIED
                                                </Typography>
                                                <FormGroup>
                                                  <FormControlLabel
                                                    control={
                                                      <Checkbox
                                                        name="has_skiff"
                                                        checked={
                                                          values?.has_skiff ||
                                                          false
                                                        }
                                                        onChange={
                                                          handleChangeCheckbox
                                                        }
                                                        value="has_skiff"
                                                      />
                                                    }
                                                    label="CAROLINA SKIFF"
                                                  />
                                                  <FormControlLabel
                                                    control={
                                                      <Checkbox
                                                        name="has_funchaser"
                                                        checked={
                                                          values?.has_funchaser ||
                                                          false
                                                        }
                                                        onChange={
                                                          handleChangeCheckbox
                                                        }
                                                        value="has_funchaser"
                                                      />
                                                    }
                                                    label="FUN CHASER"
                                                  />
                                                  <FormControlLabel
                                                    control={
                                                      <Checkbox
                                                        name="has_seachaser"
                                                        checked={
                                                          values?.has_seachaser ||
                                                          false
                                                        }
                                                        onChange={
                                                          handleChangeCheckbox
                                                        }
                                                        value="has_seachaser"
                                                      />
                                                    }
                                                    label="SEA CHASER"
                                                  />
                                                </FormGroup>
                                              </FormControl>
                                            </Grid>
                                          </Grid>
                                          {/* Row 3 */}
                                          <Grid container>
                                            <Grid
                                              item
                                              xs={12}
                                              align="center"
                                              style={{
                                                display: "flex",
                                                gap: "15px",
                                                justifyContent: "center",
                                              }}
                                            >
                                              <Button
                                                variant="contained"
                                                color="secondary"
                                                className={classes.addDealer}
                                                type="button"
                                                onClick={() =>
                                                  history.push(
                                                    "/admin-my-sales-rep"
                                                  )
                                                }
                                              >
                                                Cancel
                                              </Button>
                                              <Button
                                                variant="contained"
                                                color="primary"
                                                className={classes.addDealer}
                                                type="submit"
                                                disabled={isSubmit}
                                              >
                                                UPDATE SALES REP
                                              </Button>
                                            </Grid>
                                          </Grid>
                                          <Grid container>
                                            <Grid item xs={12} align="center">
                                              <h2 className={classes.password}>
                                                Reset Dealer Password
                                              </h2>
                                              <Button
                                                variant="contained"
                                                color="primary"
                                                className={classes.addDealer}
                                                type="button"
                                                onClick={handleUpdatePassword}
                                              >
                                                RESET PASSWORD
                                              </Button>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      </form>
                                    );
                                  }}
                                </Mutation>
                              );
                            }}
                          </Mutation>
                        );
                      }}
                    </Mutation>
                  );
                }}
              </Mutation>
            );
          }
        }}
      </Query>
    </>
  );
};

export default compose(withRouter, withStyles(styles))(EditSalesRep);
